<!-- 事件评价统计 -->
<template>
    <div class='right1_container box_v'>
        <div class="title1">事件评价</div>
        <div class="chartEventScore box_f1" id="event_averageScore"></div>
        <div class="box box_v legend">
            <div class="box legend_item" v-for="(item,index) in legend" :key="`event_score_${index}`">
                <div class="trapzoid" :style="'borderTopColor:'+item.color"></div>
                <div class="text">{{item.text}}</div>
            </div>
        </div>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import echarts from 'echarts'
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
    //这里存放数据
        return {
            legend:[{
                text:'5分 100%',
                color:'#00A0E9'
            },{
                text:'4分 100%',
                color:'#015AFF'
            },{
                text:'3分 100%',
                color:'#FFF100'
            },{
                text:'2分 100%',
                color:'#F9B44F'
            },{
                text:'1分 100%',
                color:'#FF8212'
            }],
            evaluationData:[]
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        getData(){
            this.$get(this.urlobj.monitor_eventEvaluateCount).then(res=>{
                let sum = 0
                let evaluationData = res.rows.map(item=>{
                    sum+= parseInt(item.count)
                    return{
                        value: +item.count, 
                        name: item.starts+'分'
                    }
                })
                this.evaluationData = evaluationData.reverse()
                console.log(this.evaluationData,sum)
                this.legend.forEach((item,index)=>{
                    item.text = evaluationData[index].name + '  ' +(evaluationData[index].value/sum*100).toFixed(2)+'%'
                })
                this.initEcharts()
            })
        },
        initEcharts(){
            let echart = echarts.init(document.getElementById('event_averageScore'));
            let option = {
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b}: {c} ({d}%)'
                },
                color:['#00A0E9','#015AFF','#FFF100','#F9B44F','#FF8212'],
                series: [
                    {
                        name: '访问来源',
                        type: 'pie',
                        radius: ['40%', '70%'],
                        avoidLabelOverlap: false,
                        label: {
                            show: true,
                            position: 'center',
                            color:'#fff',
                            fontSize: '14',
                            fontWeight: 'bold',
                            formatter: '事件\n评价',
                        },
                        emphasis: {
                            label: {
                                show: false,
                                fontSize: '14',
                                fontWeight: 'bold',
                                formatter: '{b}\n {d}%',
                            }
                        },
                        labelLine: {
                            show: false
                        },
                        data: this.evaluationData
                    }
                ]
            };
            echart.setOption(option)
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getData()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
       
    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.right1_container{
    width: 100%;
    background-image: url('../../../../assets/images/monitorpy/right-s.png');
    background-size: 100% 100%;
    //height:100%;
    margin-bottom:10px;
    position: relative;
}
.title1{
    font-size: 18px;
    font-weight: bold;
    color: #FFFFFF;
    margin:20px 0 0 40px
}
.chartEventScore{
    width:70%;
    height:100%;
}
.legend{
    position: absolute;
    left:60%;
    top: 50%;
    margin-top:-49px;
    .legend_item{
        font-size: 14px;
        color: #65BAFF;
        line-height: 29px;
        align-items: center;
    }
}
.trapzoid {
    width:15px;
    height:0px;
    border-top:9px solid red;
    border-right:4px solid transparent;
    border-left:4px solid transparent;
    margin-right:10px
}
</style>